export default {
    formatDate(the_date) {
        return (new Date(the_date)).toLocaleDateString()
    }
}